// Add new feature toggles here
export type FeatureToggles = {
  PageTitleTestToggle: boolean;
  CoveoUserAffiliateToggle: boolean;
  CoveoPageAffiliateToggle: boolean;
  CoveoJobCategoryToggle: boolean;
};

// Add new feature toggles item ids here
export const FeatureToggleIds = {
  PageTitleTestToggle: '29688F29900346F0B3D380F441DADB98',
  CoveoUserAffiliateToggle: '7260E6ED50DB43649B73760083DCDED7',
  CoveoPageAffiliateToggle: 'D75BF5139D12456DAA00994024C75AC4',
  CoveoJobCategoryToggle: 'EA62D49D9ECF42A2949AE23F81E735FF',
};
